import React, { Component } from "react";
import { connect } from "react-redux";
import { Checkbox, Divider, message, Tabs } from "antd";
import {
  Button,
  CircularProgress,
  DialogActions,
  DialogTitle,
} from "@material-ui/core";
import { markOrderDetailsThunk } from "../../redux/MarkOrderRedux/Action";
import {
  clickPostRecommendationThunk,
  updatePackageStatusThunk,
  shipRocketRecommendationThunk,
} from "../../redux/packageTrackerRedux/Action";
import {
  OrderWrapper,
  CustomField,
  MakerWrapper,
  CustomDialog,
} from "./MarkOrder.style";
import UserData from "./Components/UserData";
import * as Yup from "yup";
import { Formik } from "formik";
import DialogMark from "./Components/DialogMark";
import CancelOrderDialog from "./Components/CancelOrderDialog";
import {
  cancelOrderThunk,
  sendSelectedSMSThunk,
} from "../../redux/CancerOrderRedux/action";
import { withRouter } from "react-router-dom";
import { RESET_MARK_ORDER_STATE } from "./MarkUtil";
import TitleWrapper from "../../components/TitleWrap/TitleWrap";
import {
  BottomWrap,
  MedDetailsWrap,
  MedsMissing,
  MedSubBtn,
} from "../PickerOrder/PickerOrder.style";
import {
  saveMissingMedicineDetails,
  clearPickerDetails,
} from "../../redux/PickerOrder/Action";
import {
  getScannedCheckerOrderDetailsThunk,
  saveCheckerMissingMedicineDetails,
  fetchDeskDetailsThunk,
} from "../../redux/newCheckerRedux/Action";
import IncrementDecrementInput from "../../components/IncrementDecrementInput/IncrementDecrementInput";
import OfflinePage from "../OfflinePage/OfflinePage";
import UserGreeting from "../../components/UserGreeting/UserGreeting";
import { Base64func } from "../../components/Base64Func/Base64func";
import BarcodeScanner from "../../components/BarcodeScanner/BarcodeScanner";
import { ROLES, warehouseId } from "../../constants";
import { AiOutlineScan } from "react-icons/ai";
import { FiPrinter } from "react-icons/fi";
import { Modal } from "antd";
import { addToCheckerLog } from "../../redux/MedicineLog/action";

const { TabPane } = Tabs;

export class MarkOrder extends Component {
  state = {
    orderNo: null,
    loaderStatus: false,
    dialogToggle: false,
    packageId: null,
    showCheckerSection: false,
    openCancelDialog: false,
    medicineList: [],
    missingMedicineDetails: [],
    batchesToSend: [],
    batchesToSendId: [],
    isMissingMedVisible: false,
    medServiceConfirm: false,
    // checkerOnline: false,
    showScannerScreen: false,
    invoicePrint: false,
    showPreview: false,
  };

  componentDidMount = () => {
    // const storedSelectedOption =
    //   JSON.parse(localStorage.getItem("userOnline")) || false;
    // this.setState({ checkerOnline: storedSelectedOption });

    if (
      this.props.userInfo &&
      this.props.userInfo.role &&
      !this.props.userInfo.role.find(
        (o) => o.roleName === ROLES.CHECKER_ROLE
      ) &&
      !this.props.userInfo.role.find(
        (o) => o.roleName === ROLES.ADMIN_CHECKER_ROLE
      )
    ) {
      message.error("You are not Authorized to access this section.");
      this.props.history.push("/");
    }

    /*  window.open(
      "https://tm-storage-bucket-prod.s3.ap-south-1.amazonaws.com/Images/OrderPDF/2058112/FinalOrderPDF.pdf",
      "_blank"
    ); */
  };

  // componentDidUpdate() {
  //   setInterval(() => {
  //     const storedSelectedOption =
  //       JSON.parse(localStorage.getItem("userOnline")) || false;
  //     this.setState({ checkerOnline: storedSelectedOption });
  //   }, 500);
  // }

  onChangeBoxStatusHandler = (sourceBox) => {
    if (this.state.packageId && this.state.orderNo) {
      let payload = {
        packageStatusId: this.state.packageId,
        awbNoPrinted: false,
        orderId: this.state.orderNo,
        boxSource: sourceBox,
        history: this.props.history,
      };
      this.setState({ loaderStatus: true });
      this.props
        .updatePackageStatusThunk(payload, this.props.access_token)
        .then(() => {
          if (this.props.pdf?.updatePackageSuccess) {
            message.success(this.props.pdf?.updatePackageSuccess?.OK, 5);
            this.formik?.resetForm();
            this.setState({ ...RESET_MARK_ORDER_STATE }, () => {
              this.handleClose();
            });
          } else {
            message.error(this.props.pdf?.updatePackageError, 2);
            this.setState({ loaderStatus: false });
          }
        });
    } else {
      message.error("Please enter Order Id");
    }
  };

  saveMeds() {
    this.setState({ packageId: 179 });
    let { batchesToSend } = this.state;
    let findZero = 0;
    if (batchesToSend.length > 0) {
      let dataList = [];
      batchesToSend.map((e) => {
        if (!e.id && e.quantity == 0) {
          findZero++;
        }

        this.setState({ orderNo: e.orderId });

        let temp = {};
        temp.name = e.name;
        temp.productCode = e.productCode;
        temp.quantity = e.quantity;
        temp.batchNumber = e.batchNumber;
        temp.orderId = e.orderId;
        temp.active = true;
        temp.invoiceBatchtId = e.invoiceBatchtId;
        temp.warehouseId = warehouseId;
        if (e.id) {
          temp.id = e.id;
        }
        if (e.quantity == 0) {
          temp.active = false;
        }
        dataList.push(temp);
      });

      if (findZero > 0) {
        message.error(
          "Quantity 0 found! Please Add quantity or uncheck the medicine"
        );
        return;
      }
      let data = {};
      data.missingMedicineDetailsList = dataList;
      data.access_token = this.props.access_token;
      data.isPicker = false;

      this.props.saveMissingMedicineDetails(data).then(() => {
        if (this.props.pickerDetails.saveMedsSuccess) {
          message.success(this.props.pickerDetails.saveMedsSuccess);
          this.setState({
            batchesToSendId: [],
            batchesToSend: [],
          });
          // this.getPickerDetails(true);
          // this.setState({ orderNo: null });
          // this.handleClickOpen(179);
          this.onChangeBoxStatusHandler(null);
          this.setState({
            packageId: null,
            orderNo: null,
            medServiceConfirm: false,
            isMissingMedVisible: false,
          });
          // this.props.clearPickerDetails();
        } else if (this.props.pickerDetails.saveMedsFailure) {
          message.error(this.props.pickerDetails.saveMedsFailure, 2);
          this.setState({
            packageId: null,
            orderNo: null,
            medServiceConfirm: false,
            isMissingMedVisible: false,
          });
        } else {
          message.error("Something went wrong", 2);
          this.setState({
            packageId: null,
            orderNo: null,
            medServiceConfirm: false,
            isMissingMedVisible: false,
          });
        }
      });
    } else {
      message.error("Looks like you haven't edited anything yet!", 2);
      this.setState({
        packageId: null,
        orderNo: null,
        medServiceConfirm: false,
      });
    }
  }

  markOrderHandler = (values, reload = false) => {
    let { checkList } = this.state;

    if (!reload) {
      message.loading("Loading Details...", 0);
    }

    this.setState({
      orderNo: values.orderId,
      // showScannerScreen: true,
    });

    this.props
      .getScannedCheckerOrderDetailsThunk({
        access_token: this.props.access_token,
        warehouseId: warehouseId,
        orderId: values.orderId,
        history: this.props.history,
      })
      .then(() => {
        if (this.props.checkerDetails?.newScannedCheckerOrderError) {
          message.error(this.props.checkerDetails?.newScannedCheckerOrderError);
          this.setState({ loaderStatus: false });
        } else {
          let newItem = {};
          newItem.orderId = this.props.checkerDetails?.newScannedCheckerOrderDetailsSuccess?.orderId;
          newItem.MedList = this.props.checkerDetails?.newScannedCheckerOrderDetailsSuccess?.medicineDetails;

          this.props.addToCheckerLog({
            checkerLog: this.props.checkerLog,
            newOrder: newItem,
          });
          // this.props.checkerDetails?.newScannedCheckerOrderDetailsSuccess?.medicineDetails.map(
          //   (item) =>
          //     this.props.history.push(
          //       `/checker-order/orderId=${Base64func(item.orderId, "encode")}`
          //     )
          // );
          this.props.history.push(
            `/checker-order/orderId=${Base64func(
              this.props.checkerDetails?.newScannedCheckerOrderDetailsSuccess
                ?.orderId,
              "encode"
            )}`
          );
          this.setState({ loaderStatus: false, showCheckerSection: true });

          let medicineList = [];
          let productCodeList = [];
          let missingMedicineDetails = [];

          this.props.checkerDetails?.newScannedCheckerOrderDetailsSuccess?.medicineDetails.map(
            (e) => {
              if (!productCodeList.includes(e.productCode)) {
                productCodeList.push(e.productCode);
                let tempArray = [];

                let activeCount = 0;
                this.props.checkerDetails?.newScannedCheckerOrderDetailsSuccess?.medicineDetails.map(
                  (f) => {
                    if (f.productCode == e.productCode) {
                      let tempDetails = f;
                      let ogQty = f.quantity;
                      tempDetails.quantity = 0;
                      this.props.checkerDetails?.newScannedCheckerOrderDetailsSuccess?.missingMedicineDetails?.map(
                        (g) => {
                          if (g.invoiceBatchtId == f.invoiceBatchtId) {
                            tempDetails = g;
                            activeCount++;
                          }
                        }
                      );
                      tempDetails.ogQty = ogQty;
                      tempArray.push(tempDetails);
                    }
                  }
                );

                let medicineDetails = {};
                medicineDetails.name = e.name;
                medicineDetails.productCode = e.productCode;
                medicineDetails.orderId = e.orderId;
                medicineDetails.batches = tempArray;
                if (activeCount > 0) {
                  medicineDetails.activeMed = true;
                  checkList--;
                }
                medicineList.push(medicineDetails);
              }
            }
          );

          checkList = checkList + medicineList.length;
          medicineList = medicineList.sort((a, b) =>
            a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
          );
          this.setState({
            checkList: checkList,
            medicineList: medicineList,
            missingMedicineDetails: missingMedicineDetails,
          });

          message.destroy();
        }
      });
  };
  handleClickOpen = (packageId) => {
    this.setState({ dialogToggle: true, packageId: packageId });
  };

  handleClose = () => {
    this.setState({ dialogToggle: false, packageId: null });
  };

  handleMissingScreen = () => {
    if (this.state.isMissingMedVisible) {
      this.setState({ isMissingMedVisible: false });
    } else {
      this.setState({ isMissingMedVisible: true });
    }
  };

  handleCloseForBoxVerified = () => {
    this.setState({ openCancelDialog: false, packageId: null });
  };

  handleBatchEdit(value, medKey, batchKey) {
    let { batchesToSend, batchesToSendId } = this.state;
    let medicineList = this.state.medicineList;
    medicineList[medKey].batches[batchKey]["quantity"] = value;

    let tempBatchArray = batchesToSend;

    if (
      batchesToSendId.includes(
        medicineList[medKey].batches[batchKey].invoiceBatchtId
      )
    ) {
      batchesToSend[
        batchesToSendId.indexOf(
          medicineList[medKey].batches[batchKey].invoiceBatchtId
        )
      ] = medicineList[medKey].batches[batchKey];
    } else {
      batchesToSend.push(medicineList[medKey].batches[batchKey]);
      batchesToSendId.push(
        medicineList[medKey].batches[batchKey].invoiceBatchtId
      );
    }

    this.setState({
      batchesToSendId: batchesToSendId,
      batchesToSend: tempBatchArray,
      medicineList: medicineList,
    });
  }

  handleChecked(key, value) {
    let medicineList = this.state.medicineList;
    medicineList[key].activeMed = value;
    let checkList = this.state.checkList;

    if (value) {
      checkList--;
    } else {
      checkList++;
      medicineList[key].batches.map((e, i) => {
        if (!e.id) {
          medicineList[key].batches[i].quantity = 0;
        }
      });
    }
    this.setState(
      {
        medicineList: medicineList,
        checkList: checkList,
      },
      () => {
        if (this.state.batchesToSendId.length > 0 && !value) {
          let { batchesToSend, batchesToSendId } = this.state;

          medicineList[key].batches.map((e) => {
            if (batchesToSendId.includes(e.invoiceBatchtId)) {
              batchesToSendId.splice(
                batchesToSendId.indexOf(e.invoiceBatchtId),
                1
              );
              batchesToSend.splice(
                batchesToSendId.indexOf(e.invoiceBatchtId),
                1
              );

              this.setState({
                batchesToSendId,
                batchesToSend,
              });
            }
          });
        }
      }
    );
  }

  markBoxVerifedHandler = (sourceBox) => {
    let data = {
      access_token: this.props.access_token,
      paymentType: this.props.orderContent?.markOrderDetails?.paymentType,
      orderId: this.state.orderNo,
      history: this.props.history,
    };
    if (this.props.orderContent?.markOrderDetails?.shippingPartnerId === 255) {
      this.props.clickPostRecommendationThunk(data).then(() => {
        if (
          this.props.cpSuccess &&
          this.props.cpSuccess[0]?.pincode_serviceable
        ) {
          this.onChangeBoxStatusHandler(sourceBox);
        } else {
          this.setState({
            dialogToggle: false,
            openCancelDialog: true,
          });
          message.error("Pincode is not serviceable");
        }
      });
    } else if (
      this.props.orderContent?.markOrderDetails?.shippingPartnerId === 256
    ) {
      this.props.shipRocketRecommendationThunk(data).then(() => {
        if (this.props.srSuccess?.status === 200) {
          this.onChangeBoxStatusHandler(sourceBox);
        } else {
          this.setState({
            dialogToggle: false,
            openCancelDialog: true,
          });
          message.error("Pincode is not serviceable");
        }
      });
    } else {
      message.error("No shipping partner found");
    }
  };

  cancelOrderHandler = () => {
    if (this.props.cancelReason && this.state.orderNo) {
      let cancelPayload = {
        orderId: this.state.orderNo,
        reasonId: this.props.cancelReason.reasonMaster.reasonId,
        notes: this.props.cancelReason.reasonMaster.value,
        access_token: this.props.access_token,
        history: this.props.history,
      };
      this.props.cancelOrderThunk(cancelPayload).then(() => {
        if (this.props.logCancel.cancelMsg) {
          let templatePayload = {
            orderId: this.state.orderNo,
            smsTemplate: this.props.cancelReason.smsTemplate,
            access_token: this.props.access_token,
            history: this.props.history,
          };
          this.props.sendSelectedSMSThunk(templatePayload).then(() => {
            if (this.props.logCancel.smsTemplate) {
              message.success("Order cancelled");
              this.formik?.resetForm();
              this.setState(RESET_MARK_ORDER_STATE);
            }
          });
        } else {
          message.error("Something went wrong, please try again.");
        }
      });
    } else {
      message.error("Something went wrong, please try again.");
    }
  };

  updateBoxId = (value) => {
    this.setState({ showScannerScreen: false });
  };

  render() {
    let { orderContent } = this.props;
    return (
      <div className="centerScreen">
        {this.props.isOnline ? (
          <MakerWrapper>
            <UserGreeting />
            <div style={{ marginTop: "25px" }}>
              <TitleWrapper title={"Order Checker"} />
              <div className="inputWrap">
                <DialogMark
                  loaderStatus={this.state.loaderStatus}
                  dialogToggle={this.state.dialogToggle}
                  handleClose={this.handleClose}
                  markBoxVerifedHandler={this.markBoxVerifedHandler}
                  onChangeBoxStatusHandler={this.onChangeBoxStatusHandler}
                  packageId={this.state.packageId}
                />

                <CancelOrderDialog
                  dialogToggle={this.state.openCancelDialog}
                  handleClose={this.handleCloseForBoxVerified}
                  cancelOrderHandler={this.cancelOrderHandler}
                />
                <button
                  className="bbtn"
                  disabled={this.props.isLoading}
                  onClick={() =>
                    this.setState({
                      showScannerScreen: true,
                      invoicePrint: false,
                    })
                  }
                >
                  <AiOutlineScan /> Scan the barcode
                </button>
                <Divider style={{ margin: "60px 0" }}>Or</Divider>
                <Formik
                  initialValues={{
                    orderId: "",
                  }}
                  validationSchema={Yup.object().shape({
                    orderId: Yup.number().typeError("Number").required(),
                  })}
                  onSubmit={(values) => {
                    this.markOrderHandler(values);
                  }}
                  innerRef={(p) => (this.formik = p)}
                >
                  {({
                    errors,
                    handleSubmit,
                    touched,
                    values,
                    handleChange,
                  }) => (
                    <form noValidate onSubmit={handleSubmit}>
                      <OrderWrapper>
                        <div className="inputWrap">
                          <CustomField
                            placeholder="Enter Order Id"
                            type="number"
                            variant="outlined"
                            name="orderId"
                            label="Order Id"
                            value={values.orderId}
                            error={Boolean(touched.orderId && errors.orderId)}
                            onChange={handleChange}
                            // autoFocus
                            min={0}
                          />
                        </div>

                        <div className="btnWrap">
                          <Button
                            // variant="contained"
                            // color="primary"
                            type="submit"
                            disabled={this.state.loaderStatus}
                          >
                            {this.state.loaderStatus ? (
                              <CircularProgress size={20} />
                            ) : (
                              "Search"
                            )}
                          </Button>
                        </div>
                      </OrderWrapper>
                    </form>
                  )}
                </Formik>
                <br />

                <button
                  className="bbtn"
                  disabled={this.props.isLoading}
                  onClick={() =>
                    this.setState({
                      showScannerScreen: true,
                      invoicePrint: true,
                    })
                  }
                >
                  <FiPrinter /> Print Invoice
                </button>
              </div>
              <Modal
                title={"Invoice"}
                visible={this.state.showPreview}
                onCancel={() =>
                  this.setState({ showPreview: false }, () => {
                    /*  setTimeout(() => {
                      this.props.history.push("/markorder");
                    }, 200); */
                  })
                }
                footer={null}
                bodyStyle={{ padding: "10px" }}
              >
                <div>
                  <iframe
                    style={{
                      width: "100%",
                      height: "60vh",
                      "border-radius": "4px",
                    }}
                    src="https://docs.google.com/viewer?url=https://tm-storage-bucket-prod.s3.ap-south-1.amazonaws.com/Images/OrderPDF/2058112/FinalOrderPDF.pdf&embedded=true"
                  >
                    Loading...
                  </iframe>
                </div>
              </Modal>
              {/* <button
                onClick={() => {
                  window.open(
                    "https://tm-storage-bucket-prod.s3.ap-south-1.amazonaws.com/Images/OrderPDF/2058112/FinalOrderPDF.pdf",
                    "_blank"
                  );
                  this.setState({
                    showPreview: true,
                  });
                }}
              >
                Show PDF
              </button> */}
            </div>

            {this.state.showScannerScreen && (
              <BarcodeScanner
                scan={this.state.showScannerScreen}
                camera={this.state.showScannerScreen}
                redirect={
                  this.state.invoicePrint ? "checkerInvoice" : "checker"
                }
                orderId={this.state.orderNo}
                history={this.props.history}
                getBoxId={this.updateBoxId}
              />
            )}

            {orderContent?.markOrderDetails &&
              this.state.showCheckerSection && (
                <UserData
                  content={orderContent?.markOrderDetails}
                  handleClickOpen={this.handleClickOpen}
                  handleClose={this.handleClose}
                  handleMissingMedScreen={this.handleMissingScreen}
                />
              )}

            {orderContent?.markOrderDetails &&
            this.state.showCheckerSection &&
            this.state.isMissingMedVisible ? (
              <React.Fragment style={{ width: "100%" }}>
                <MedsMissing>
                  <Tabs defaultActiveKey="1">
                    <TabPane tab="Medicine Details" key="1">
                      {this.state.medicineList.length > 0 ? (
                        <div>
                          {this.state.medicineList.map((e, i) => {
                            return (
                              <MedDetailsWrap>
                                <div className="medTitleWrap">
                                  <Checkbox
                                    checked={e.activeMed}
                                    onChange={(f) => {
                                      this.handleChecked(i, !e.activeMed);
                                    }}
                                  >
                                    <div className="medTitle">{e.name}</div>
                                  </Checkbox>
                                </div>
                                <div className="batchWrap">
                                  {e.batches.length > 0 ? (
                                    e.batches.map((f, j) => {
                                      return (
                                        <div className="batchDetailsWrap">
                                          <div className="name">
                                            {f.batchNumber}
                                          </div>
                                          <div className="qty">{f.ogQty}</div>
                                          <div className="editQty">
                                            {/* <InputNumber
                                          addonBefore={"-"}
                                          addonAfter={"+"}
                                          disabled={!e.activeMed}
                                          min={0}
                                          max={f.ogQty}
                                          value={f.quantity}
                                          onChange={(e) => {
                                            this.handleBatchEdit(e, i, j);
                                          }}
                                        /> */}
                                            <div>
                                              <IncrementDecrementInput
                                                disabled={!e.activeMed}
                                                min={0}
                                                max={f.ogQty}
                                                value={f.quantity}
                                                step={1}
                                                handleChange={(e) => {
                                                  this.handleBatchEdit(e, i, j);
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })
                                  ) : (
                                    <div>{"No Batches Found"}</div>
                                  )}
                                </div>
                              </MedDetailsWrap>
                            );
                          })}
                          <MedSubBtn
                            className={
                              this.state.batchesToSendId.length === 0
                                ? "btnDisabled"
                                : ""
                            }
                            disabled={
                              this.state.batchesToSendId.length === 0
                                ? true
                                : false
                            }
                            onClick={() => {
                              this.setState({ medServiceConfirm: true });
                              // this.saveMeds();
                            }}
                          >
                            {"Submit"}
                          </MedSubBtn>
                        </div>
                      ) : (
                        <div className="medError">{"No Medicines Found"}</div>
                      )}
                    </TabPane>
                  </Tabs>
                </MedsMissing>
              </React.Fragment>
            ) : (
              ""
            )}

            <CustomDialog
              open={this.state.medServiceConfirm}
              onClose={() => this.setState({ medServiceConfirm: false })}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              maxWidth={"md"}
            >
              <DialogTitle id="alert-dialog-title">
                {"Are you sure?"}
              </DialogTitle>
              <DialogActions>
                <Button
                  onClick={() => this.setState({ medServiceConfirm: false })}
                  color="primary"
                >
                  Close
                </Button>
                <Button
                  onClick={() => this.saveMeds()}
                  variant="contained"
                  color="primary"
                >
                  Yes
                </Button>
              </DialogActions>
            </CustomDialog>
          </MakerWrapper>
        ) : (
          <OfflinePage />
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  pdf: state.packageTrackerReducer,
  orderContent: state.markorderReducer,
  cpSuccess: state.packageTrackerReducer?.CPSuccess,
  srSuccess: state.packageTrackerReducer?.SRSuccess,
  cancelReason: state.markorderReducer.markOrderDetails,
  logCancel: state.cancelOrderReducer,
  pickerDetails: state.pickerorderReducer,
  checkerDetails: state.newCheckerOrderReducer,
  onlineCheck:
    state.onlineStatusReducer?.isUserOnine?.response?.availableStatus?.value,
  isOnline: state.statusReducer?.isOnline,
  isLoading: state.LoaderReducer?.isLoading,
  checkerLog: state.MedicineLogReducer?.checkerLog,
});

export default withRouter(
  connect(mapStateToProps, {
    markOrderDetailsThunk,
    updatePackageStatusThunk,
    clickPostRecommendationThunk,
    cancelOrderThunk,
    sendSelectedSMSThunk,
    saveMissingMedicineDetails,
    clearPickerDetails,
    getScannedCheckerOrderDetailsThunk,
    saveCheckerMissingMedicineDetails,
    shipRocketRecommendationThunk,
    fetchDeskDetailsThunk,
    addToCheckerLog,
  })(MarkOrder)
);
